import React from "react"

const Boxes = ({ previewData, headerColor, textColor }) => {
  return (
    <div
      style={{
        paddingTop: "10px",
        flexWrap: "wrap",
        flexDirection: "row",
        display: "flex",
        marginBottom: "10px",
      }}
    >
      {previewData.map((x, index) => (
        <div
          style={{
            backgroundImage: `url(${x?.img})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            boxShadow: "inset 0 0 0 100px rgb(0 0 0 / 40%)",
            width: "45%",
            height: "110px",
            margin: "4px",
            textAlign: "-webkit-center",
            display: "flex",
            alignItems: "flex-end",
          }}
          key={index}
        >
          <div
            style={{
              background: "black",
              width: "100%",
              color: "white",
            }}
          >
            {x?.name}
          </div>
        </div>
      ))}
    </div>
  )
}

export default Boxes
